<template>
  <v-container>
    <h1 class="text-center">🔑 Lizenzen</h1>

    <v-card outlined class="pa-4 mb-6">
      <v-card-title class="text-subtitle-1 font-weight-bold pl-0 pt-0">Lizenz vergeben</v-card-title>
      <v-form ref="form" v-model="formValid">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              label="Twitch-Username"
              v-model="twitchUsername"
              :rules="[(v) => !!v || 'Pflichtfeld']"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              :items="licenseTypeOptions"
              item-text="label"
              item-value="value"
              label="Lizenztyp"
              v-model="licenseType"
              :rules="[(v) => !!v || 'Pflichtfeld']"
              outlined
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              label="Notiz (optional)"
              v-model="note"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-btn color="primary" :loading="granting" @click="grantLicense">Lizenz vergeben</v-btn>
      </v-form>
    </v-card>

    <v-progress-linear v-if="loading" indeterminate class="mb-4"></v-progress-linear>
    <v-simple-table v-else>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Username</th>
            <th>Typ</th>
            <th>Status</th>
            <th>Erstellt am</th>
            <th>Notiz</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in licenses" :key="item.id">
            <td>{{ item.user_name || item.user_id }}</td>
            <td>{{ licenseTypeLabel(item.license_type) }}</td>
            <td><v-chip small :color="statusColor(item.status)">{{ statusLabel(item.status) }}</v-chip></td>
            <td>{{ new Date(item.created_at).toLocaleString('de-DE') }}</td>
            <td>{{ item.note }}</td>
            <td>
              <v-btn
                v-if="item.status === 'available'"
                small
                outlined
                color="red"
                :loading="revokingId === item.id"
                @click="revoke(item)"
              >
                Widerrufen
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-snackbar
      v-model="result.show"
      timeout="3000"
      :color="result.success ? 'green' : 'red'"
    >
      {{ result.message }}
    </v-snackbar>
  </v-container>
</template>

<script>

import BackendService from '@/services/BackendService';

const LICENSE_TYPE_LABELS = {
  twitch_bot: 'Twitch-Bot',
  twitch_dc_bot: 'Twitch-Bot + Discord',
  dc_bot_only: 'Nur Discord',
};

const STATUS_LABELS = {
  available: 'Frei',
  consumed: 'Belegt',
  revoked: 'Widerrufen',
};

const STATUS_COLORS = {
  available: 'green',
  consumed: 'blue-grey',
  revoked: 'red',
};

export default {
  data() {
    return {
      formValid: false,
      twitchUsername: '',
      licenseType: null,
      note: '',
      granting: false,
      revokingId: null,
      loading: true,
      licenses: [],
      licenseTypeOptions: Object.entries(LICENSE_TYPE_LABELS).map(([value, label]) => ({ value, label })),
      result: {
        show: false,
        success: false,
        message: '',
      },
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    licenseTypeLabel(type) {
      return LICENSE_TYPE_LABELS[type] || type;
    },
    statusLabel(status) {
      return STATUS_LABELS[status] || status;
    },
    statusColor(status) {
      return STATUS_COLORS[status] || 'grey';
    },
    load() {
      this.loading = true;
      BackendService.listLicenses().then((data) => {
        this.licenses = data.data.licenses;
      }).finally(() => {
        this.loading = false;
      });
    },
    grantLicense() {
      if (!this.$refs.form.validate()) return;
      this.granting = true;
      BackendService.createLicense({
        twitch_username: this.twitchUsername,
        license_type: this.licenseType,
        note: this.note,
      }).then(() => {
        this.result = { show: true, success: true, message: 'Lizenz vergeben!' };
        this.twitchUsername = '';
        this.licenseType = null;
        this.note = '';
        this.$refs.form.resetValidation();
        this.load();
      }).catch((error) => {
        const message = error.response && error.response.status === 404
          ? 'Twitch-Username nicht gefunden.'
          : 'Vergabe fehlgeschlagen.';
        this.result = { show: true, success: false, message };
      }).finally(() => {
        this.granting = false;
      });
    },
    revoke(item) {
      this.revokingId = item.id;
      BackendService.revokeLicense({ license_id: item.id }).then(() => {
        this.result = { show: true, success: true, message: 'Lizenz widerrufen!' };
        this.load();
      }).catch(() => {
        this.result = { show: true, success: false, message: 'Widerruf fehlgeschlagen (Lizenz evtl. schon belegt).' };
      }).finally(() => {
        this.revokingId = null;
      });
    },
  },
};
</script>
